import React from 'react';
import { Alert, Typography } from '@one-thd/sui-atomic-components';

export const LORPPickupCostAlert = () => {
  return (
    <div className="sui-pb-4">
      <Alert status="info" size="large">
        <div className="sui-flex sui-flex-col sui-gap-2">
          <Typography variant="body-base">
            <div className="sui-flex sui-space-x-1">
              <Typography weight="bold">Your Pickup Cost:</Typography>
              <Typography color="success" weight="bold">
                FREE
              </Typography>
            </div>
          </Typography>
        </div>
      </Alert>
    </div>
  );
};
